import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/sightglass_analytics_event.py
export const SEARCH_ANALYTICS_ACTIONS = {
  CLICKED_SEARCH_RESULT: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'clicked_search_result',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_ASSISTED_SEARCH_MODAL: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'opened_ai_assisted_search_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_AI_ASSISTED_SEARCH_THUMBSUP: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'submitted_ai_assisted_search_thumbsup',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_AI_ASSISTED_SEARCH_THUMBSDOWN: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'submitted_ai_assisted_search_thumbsdown',
    actionCategory: ACTION_CATEGORY.READ,
  },
};

export const BLAST_ANALYTICS_ACTIONS = {
  OPENED_BLAST_MODAL: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'opened_blast_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_BLAST_MODAL: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'closed_blast_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_BLAST_SEARCH: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'submitted_blast_search',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SWITCHED_TABLE_ALIGNMENT_VIEW: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'switched_table_alignment_view',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SWITCHED_BAR_PAIRWISE_VIEW: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'switched_bar_pairwise_view',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_COMPARE_RESULTS_BUTTON: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'clicked_compare_results_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CHANGED_COLORING_SCHEME: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'changed_coloring_scheme',
    actionCategory: ACTION_CATEGORY.READ,
  },
};

export const BULK_ACTION_ON_SEARCH_RESULTS = {
  [ACTION_CATEGORY.READ]: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'initiated_bulk_action_on_search_results',
    actionCategory: ACTION_CATEGORY.READ,
  },
  [ACTION_CATEGORY.WRITE]: {
    module: ANALYTICS_MODULE.SIGHTGLASS,
    action: 'initiated_bulk_action_on_search_results',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
